import { render } from "./PagantesChart.vue?vue&type=template&id=809714da"
import script from "./PagantesChart.vue?vue&type=script&lang=js"
export * from "./PagantesChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__